/**
 * Created by sxp23 on 2/15/2018.
 */
import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs';

import {SessionStorageService} from 'ngx-webstorage';


@Injectable()
export class SharedService {

  // Observable sources
  //private didHttpCall = new Subject<boolean>();
  private homeAddress = new Subject<string>();
  private pwsId = new Subject<string>();
  private pwsLatLng = new Subject<string>();

  private flowFlag:string;
  private flowFlag2:string;
  private flowFlag2Lat:string;
  private flowFlag2Lng:string;
  private homeAddressVal:string;
  private pwsIdVal:string;
  private latLngFrESRIMap:string;

  constructor(private sessionSt:SessionStorageService) {}

  // Observable booelan streams
 // httpCalled$ = this.didHttpCall.asObservable();
  // Observable string streams
  homeAddress$ = this.homeAddress.asObservable();
  pwsId$ = this.pwsId.asObservable();
  pwsLatLng$ = this.pwsLatLng.asObservable();

  // Service message commands
  /*addHttpCall(isHttpCalled: boolean) {
    this.didHttpCall.next(isHttpCalled);
  }*/
  setHomeAddress(address: string) {
    //console.log("setHomeAddress in Shared Service:", address)
    this.sessionSt.store('homeAddressVal',btoa(JSON.stringify(address)));
    this.homeAddress.next(address);
    this.homeAddressVal = address;
    this.sessionSt.clear('pwsIdVal');
    this.sessionSt.clear('latLngFrESRIMap');
    this.pwsIdVal = null;
  }
  getHomeAddress():string {
    //console.log("getHomeAddress in Shared Service:")
    if (this.sessionSt.retrieve('homeAddressVal')) {
      this.homeAddressVal = JSON.parse(atob(this.sessionSt.retrieve('homeAddressVal'))); //this.sessionSt.retrieve('homeAddressVal');
      return this.homeAddressVal;
    }
    else return null;
  }
  setPwsId(pwsId: string) {
    //console.log("setPwsId in Shared Service:", pwsId)
    this.sessionSt.store('pwsIdVal', btoa(JSON.stringify(pwsId))); //pwsId);
    this.pwsId.next(pwsId);
    this.pwsIdVal = pwsId;
    //this.sessionSt.clear('latLngFrESRIMap');
  }
  getPwsId():string{
    if (this.sessionSt.retrieve('pwsIdVal')) {
      this.pwsIdVal = JSON.parse(atob(this.sessionSt.retrieve('pwsIdVal'))); //this.sessionSt.retrieve('pwsIdVal');
      return this.pwsIdVal;
    }
    else return null;
  }

  setLatLngFrESRIMap(latLngFrESRIMap: string) {
    if (latLngFrESRIMap === null) {
      this.sessionSt.clear('latLngFrESRIMap');
    }
    else {
      this.sessionSt.store('latLngFrESRIMap', btoa(JSON.stringify(latLngFrESRIMap))); //latLngFrESRIMap);
      this.latLngFrESRIMap = latLngFrESRIMap;
    }
  }
  getLatLngFrESRIMap():string {
    if (this.sessionSt.retrieve('latLngFrESRIMap')) {
      this.latLngFrESRIMap = JSON.parse(atob(this.sessionSt.retrieve('latLngFrESRIMap'))); //this.sessionSt.retrieve('latLngFrESRIMap');
      return this.latLngFrESRIMap;
    }
    else return null;
  }
  setFlowFlag(flowFlag: string) {
    this.sessionSt.store('flowFlag', btoa(JSON.stringify(flowFlag))); //flowFlag);
    this.flowFlag = flowFlag;
  }
  getFlowFlag():string {
    if (this.sessionSt.retrieve('flowFlag')) {
      this.flowFlag = JSON.parse(atob(this.sessionSt.retrieve('flowFlag'))); //this.sessionSt.retrieve('flowFlag');
      return this.flowFlag;
    }
    else return null;
  }

  setFlowFlag2Lat(flowFlag2Lat: string) {
    this.sessionSt.store('flowFlag2Lat', btoa(JSON.stringify(flowFlag2Lat))); //flowFlag2Lat);
    this.flowFlag2Lat = flowFlag2Lat;
  }
  getFlowFlag2Lat():string {
    if (this.sessionSt.retrieve('flowFlag2Lat')) {
      this.flowFlag2Lat = JSON.parse(atob(this.sessionSt.retrieve('flowFlag2Lat'))); // this.sessionSt.retrieve('flowFlag2Lat');
      return this.flowFlag2Lat;
    }
    else return null;
  }
  setFlowFlag2Lng(flowFlag2Lng: string) {
    this.sessionSt.store('flowFlag2Lng', btoa(JSON.stringify(flowFlag2Lng))); //flowFlag2Lng);
    this.flowFlag2Lng = flowFlag2Lng;
  }
  getFlowFlag2Lng():string {
    if (this.sessionSt.retrieve('flowFlag2Lng')) {
      this.flowFlag2Lng = JSON.parse(atob(this.sessionSt.retrieve('flowFlag2Lng'))); //this.sessionSt.retrieve('flowFlag2Lng');
      return this.flowFlag2Lng;
    }
    else return null;
  }

  setPwsLatLng(pwsLatLng: string) {
    //console.log("setPwsLatLng in Shared Service:", pwsLatLng)
    //this.sessionSt.store('pwsLatLng', pwsLatLng);
    this.pwsLatLng.next(pwsLatLng);
  }
}
